import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=fdd094be&scoped=true&"
import script from "./AdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./AdminDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=fdd094be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd094be",
  null
  
)

export default component.exports